import { EventFeePayer } from "../../redux/features/event/event.types";
import { Icon } from "../icon/icon";
import { MiniHeader } from "../typography/miniHeader";
import { BgWrapper } from "../wrapper/bgWrapper";

export const EventFeePayerToggle = ({
  feePayer = "organiser",
  onChange = () => {},
  showHeader = true,
  containerClassName = "",
  className = "",
}: {
  feePayer: EventFeePayer;
  onChange: (val: EventFeePayer) => void;
  showHeader?: boolean;
  containerClassName?: string;
  className?: string;
}) => {
  const itemsClassName = `flex cursor-pointer items-center gap-4 ${className}`;

  return (
    <div className={`flex flex-col gap-[2px] ${containerClassName}`}>
      {showHeader && (
        <BgWrapper>
          <MiniHeader header="Fees" className="!text-grey-600" />
        </BgWrapper>
      )}

      <BgWrapper
        onClick={() => {
          onChange("organiser");
        }}
        className={itemsClassName}
      >
        <p className="flex flex-1 flex-col text-sm">
          <span className="font-bold text-primary">You’ll Pay The Fee</span>
          <span className="text-grey-500">
            Our fees would be deducted from each ticket sale.
          </span>
        </p>

        <Icon
          svg={
            feePayer === "organiser" ? "checkbox-active" : "checkbox-inactive"
          }
          width={20}
          height={20}
          className="text-primary"
        />
      </BgWrapper>

      <BgWrapper
        onClick={() => {
          onChange("guest");
        }}
        className={itemsClassName}
      >
        <p className="flex flex-1 flex-col text-sm">
          <span className="font-bold text-primary">Guests</span>
          <span className="text-grey-500">
            Our fee would be added to the price of your ticket.
          </span>
        </p>

        <Icon
          svg={feePayer === "guest" ? "checkbox-active" : "checkbox-inactive"}
          width={20}
          height={20}
          className="text-primary"
        />
      </BgWrapper>
    </div>
  );
};
